<template>
  <figure class="media-slot">
    <img v-if="material.image" :src="material.image" :alt="material.alt || material.label || material.description" />
    <template v-else><span class="placeholder-label">{{ material.label || 'Story page' }}</span><p>{{ material.description }}</p><small>Material not added yet</small></template>
  </figure>
</template>
<script>
export default { props: { material: { type: Object, required: true } } };
</script>
